module.exports = __webpack_public_path__ + "static/img/智慧文旅_0.385a278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/智慧文旅_0.jpg
// module id = jN9e
// module chunks = 1